"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconsSizes = void 0;
const react_1 = __importDefault(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const themes_1 = require("./themes");
var IconsSizes;
(function (IconsSizes) {
    IconsSizes["default"] = "default";
    IconsSizes["small"] = "small";
    IconsSizes["medium"] = "medium";
    IconsSizes["large"] = "large";
    IconsSizes["custom"] = "custom";
})(IconsSizes = exports.IconsSizes || (exports.IconsSizes = {}));
function Icon(props) {
    var _a, _b, _c;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : 'default';
    const { icon: IconChild } = props;
    return (react_1.default.createElement(IconChild, { className: (0, elements_ui_utils_1.classNames)((_b = themes_1.theme.sizes[size]) !== null && _b !== void 0 ? _b : '', (_c = props.className) !== null && _c !== void 0 ? _c : ''), "aria-hidden": "true" }));
}
exports.default = Icon;
//# sourceMappingURL=icon.js.map